import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`PostHog is available through `}<a parentName="p" {...{
        "href": "http://cocoapods.org"
      }}>{`CocoaPods`}</a>{` and `}<a parentName="p" {...{
        "href": "https://github.com/Carthage/Carthage"
      }}>{`Carthage`}</a>{` or you can add it as a Swift Package Manager based dependency.`}</p>
    <h3 {...{
      "id": "cocoapods"
    }}>{`CocoaPods`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-ruby",
        "metastring": "file=Podfile",
        "file": "Podfile"
      }}>{`pod "PostHog", "~> 1.1"
`}</code></pre>
    <h3 {...{
      "id": "carthage"
    }}>{`Carthage`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-ruby",
        "metastring": "file=Cartfile",
        "file": "Cartfile"
      }}>{`github "posthog/posthog-ios"
`}</code></pre>
    <h3 {...{
      "id": "swift-package-manager"
    }}>{`Swift Package Manager`}</h3>
    <p>{`Add PostHog as a dependency in your Xcode project "Package Dependencies" and select the project target for your app, as appropriate.`}</p>
    <p>{`For a Swift Package Manager based project, add PostHog as a dependency in your "Package.swift" file's Package dependencies section:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift",
        "metastring": "file=Package.swift",
        "file": "Package.swift"
      }}>{`dependencies: [
  .package(url: "https://github.com/PostHog/posthog-ios.git", from: "2.0.0")
],
`}</code></pre>
    <p>{`and then as a dependency for the Package target utilizing PostHog:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`  .target(
    name: "myApp",
    dependencies: [.product(name: "PostHog", package: "posthog-ios")]),
`}</code></pre>
    <h3 {...{
      "id": "configuration"
    }}>{`Configuration`}</h3>
    <h4 {...{
      "id": "with-objective-c"
    }}>{`With Objective-C`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`#import <PostHog/PHGPostHog.h>
#import <PostHog/PHGPostHogConfiguration.h>

// cloud-hosted
PHGPostHogConfiguration *configuration = [PHGPostHogConfiguration configurationWithApiKey:@"<ph_project_api_key>"];

// self-hosted
PHGPostHogConfiguration *configuration = [PHGPostHogConfiguration configurationWithApiKey:@"<ph_project_api_key>" 
                                                                          host:@"https://your-posthog-domain.com"];

configuration.captureApplicationLifecycleEvents = YES; // Record certain application events automatically!
configuration.recordScreenViews = YES; // Record screen views automatically!

[PHGPostHog setupWithConfiguration:configuration];
`}</code></pre>
    <h4 {...{
      "id": "with-swift"
    }}>{`With Swift`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`import PostHog

let configuration = PHGPostHogConfiguration(apiKey: "<ph_project_api_key>", host: "<ph_instance_address>") // TIP: \`host\` is optional if you use app.posthog.com

configuration.captureApplicationLifecycleEvents = true; // Record certain application events automatically!
configuration.recordScreenViews = true; // Record screen views automatically!

PHGPostHog.setup(with: configuration)
let posthog = PHGPostHog.shared()
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      